import React, { useContext, useEffect, useState } from 'react'
import { callGetApi } from '../api/ApiCaller';
import { PLAYER_TEMPLATE_LIST_GET } from '../api/ApiConst';
import { STATUS } from '../utils/Constants';
import toast from 'react-hot-toast';
import { setDataInStore, TEMPLATE_ID } from '../utils/CookiesUtils';
import { useNavigate } from 'react-router-dom';
import { useBalance } from '../BalanceContext';
import { getCurrencySymbol } from '../utils/TextUtils';

const Home = () => {
    const [templateList, setTemplateList] = useState(null);
    const navigate = useNavigate();
    const { profileDetails, getPlayerDetails, walletBalance, getWalletBalance, hiddenBalance, setHiddenBalance } = useBalance();


    useEffect(() => {
        getTemplatePlayerList();
        getPlayerDetails()
    }, []);


    const getTemplatePlayerList = () => {
        callGetApi(PLAYER_TEMPLATE_LIST_GET, {}, (response) => {
            if (response.errorCode === STATUS.SUCCESS) {
                let res = response.responsePacket;
                console.log("Template List Response:", res); // Add this to check the data structure
                setTemplateList(res);
            } else {
                toast.error(response.message);
            }
        },
            (e) => {
                toast.error(e.message);
            }
        );
    }

    // Ice Fishing uses the Halloween_20 slot template for its game data
    const handleIceNavigate = () => {
        const iceTemplate = templateList?.find(
            (t) => t.title === "Halloween_20" || t.slotGameType === "Halloween_20"
        );
        const recordId = iceTemplate?.recordId || "78b667bc-d1ac-404b-8b7f-b610a5da0032";
        setDataInStore(TEMPLATE_ID, recordId);
        // through the splash, same as the tile below
        navigate("/loading-screen");
    }

    // TV Millionario plays its own TV_Millionario_25 template
    const handleTvMillionarioNavigate = () => {
        const tvTemplate = templateList?.find(
            (t) => t.title === "TV_Millionario_25" || t.slotGameType === "TV_Millionario_25"
        );
        if (!tvTemplate) {
            toast.error("TV_Millionario_25 template not found");
            return;
        }
        setDataInStore(TEMPLATE_ID, tvTemplate.recordId);
        navigate("/tv-millionario");
    }

    // FIXED: Handle navigation based on game title or ID
    const handleNavigate = (recordId, gameTitle) => {
        setDataInStore(TEMPLATE_ID, recordId);

        const title = gameTitle ? gameTitle.toLowerCase() : "";
        // Route each template to its game screen
        if (title.includes("bomba")) {
            navigate("/halloween-bomba");
        } else if (title.includes("millionario")) {
            // TV_Millionario_25 now has its own template in the list
            navigate("/tv-millionario");
        } else if (title.includes("ice")) {
            // Era do Gelo opens on its splash, which runs its animation and then
            // hands over to the game itself.
            navigate("/loading-screen");
        } else {
            navigate("/gameplay");
        }
    }

    return (
        <div className='d-flex gap-2 col-12'>
            <div className='col-10'>
                <div className="games-grid">
                    {templateList?.map((item, index) => {
                        // Log each item to see its structure
                        console.log("Game Item:", item);
                        return (
                            <div className="game-card" key={index} onClick={() => handleNavigate(item.recordId, item.title)}>
                                <img src={`assets/img/${item.title}.png`} alt="Halloween" />
                            </div>
                        );
                    })}
                    {/* <div className="game-card" onClick={handleTvMillionarioNavigate}>
                        <img src="assets/img/Tv_Millionario.png" alt="TV Millionario" />
                    </div> */}
                </div>
            </div>
            <div className="col-2">
                <div className="p-2" style={{ background: "#1A1A1A", color: "#fff", borderRadius: "8px" }}>
                    <div style={{ background: "#2F2F2F", borderRadius: "8px" }} className="p-1 d-flex flex-column justify-content-between">
                        <span className="balance-label" style={{ fontSize: "14px", color: "#B0B0B0" }}>
                            {profileDetails?.fullName}
                        </span>
                        <div className="d-flex  align-items-center justify-content-between w-100">
                            <span
                                className="balance-amount"
                                style={{
                                    transition: "all 0.3s ease",
                                    opacity: hiddenBalance ? 0.7 : 1,
                                    letterSpacing: hiddenBalance ? "2px" : "normal",
                                    transform: hiddenBalance ? "scale(0.95)" : "scale(1)",
                                    filter: hiddenBalance ? "blur(0.5px)" : "blur(0px)"
                                }}
                            >
                                {hiddenBalance ? "••••" : getCurrencySymbol(profileDetails?.currencyCode) + " " + walletBalance?.toFixed(2)}
                            </span>
                            <div className="balance-actions d-flex gap-2" style={{ alignItems: "center" }}>
                                <svg
                                    onClick={() => setHiddenBalance(!hiddenBalance)}
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    style={{
                                        cursor: "pointer",
                                        opacity: 0.8,
                                        transition: "all 0.2s ease",
                                        padding: "2px",
                                        borderRadius: "4px"
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.opacity = "1";
                                        e.target.style.background = "rgba(255,255,255,0.1)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.opacity = "0.8";
                                        e.target.style.background = "transparent";
                                    }}
                                    title={hiddenBalance ? "Show Balance" : "Hide Balance"}
                                >
                                    {hiddenBalance ? (
                                        <>
                                            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <line x1="1" y1="1" x2="23" y2="23" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </>
                                    ) : (
                                        <>
                                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </>
                                    )}
                                </svg>
                                <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    onClick={() => getWalletBalance()}
                                    style={{
                                        cursor: "pointer",
                                        opacity: 0.8,
                                        transition: "all 0.2s ease",
                                        padding: "2px",
                                        borderRadius: "4px"
                                    }}
                                    onMouseEnter={(e) => {
                                        e.target.style.opacity = "1";
                                        e.target.style.background = "rgba(255,255,255,0.1)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.target.style.opacity = "0.8";
                                        e.target.style.background = "transparent";
                                    }}
                                    title="Refresh Balance"
                                >
                                    <path d="M23 4v6h-6M1 20v-6h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home;